export const GOOGLE_DRIVE_FILE_URL_REGEX =
	'https:\\/\\/(?:drive|docs)\\.google\\.com(?:\\/.*|)\\/d\\/([0-9a-zA-Z\\-_]+)(?:\\/.*|)';

export const GOOGLE_DRIVE_FOLDER_URL_REGEX =
	'https:\\/\\/drive\\.google\\.com(?:\\/.*|)\\/folders\\/([0-9a-zA-Z\\-_]+)(?:\\/.*|)';

export const GOOGLE_SHEETS_SHEET_URL_REGEX =
	'https:\\/\\/docs\\.google\\.com\\/spreadsheets\\/d\\/[0-9a-zA-Z\\-_]+.*\\#gid=([0-9]+)';
